import { HubFeature } from '@ats/api/cm';
import { LocDefs } from '@cm/core/localization';

const dpRoot = 'Candidates|Program History|Credentials|Criteria|';

export type CredentialCriteriaLoc = 'SPCredentialCriteriaTitleSection';

export const spCredentialCriteriaLocs: LocDefs<CredentialCriteriaLoc> = {
	SPCredentialCriteriaTitleSection: {
		defaultValue: 'Criteria',
		displayType: 'Title',
		description: 'Title for the credential criteria section.',
		displayPath: `${dpRoot}Section Title`,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
		feature: HubFeature.ExamComptiaAnsiCriteria,
	},
};

export type CredentialCriteriaLocKeys = { [key in keyof typeof spCredentialCriteriaLocs]: key };
